import React from "react";
import PanelGroupController from "../../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../../components/panels/PropertiesList";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {Query} from "react-apollo";
import gql from "graphql-tag";

const SERVICE_INFO = gql`
  query serviceInfo($serviceId: ID!) {
    infrastructureService(serviceId: $serviceId) {
      serviceId
      title
      description
      status
      tags
    }
    infrastructureServicePing(serviceId: $serviceId) {
      serviceId
      action
      occuredAt
      scheduledAt
      ranAt
    }
  }
`

const ServicePanel = (props) => {

  let elements = null;
  if (!props.serviceId) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "infrastructureService.serviceId", label: "Id", type: "string"},
      {prop: "infrastructureService.title", label: "Title", type: "string"},
      {prop: "infrastructureService.description", label: "Description", type: "text"},
      {prop: "infrastructureService.status", label: "Status", type: "string"},
      {prop: "infrastructureService.tags", label: "Tags", type: "array"},
      
      {prop: "ping_category", label: "Service Ping", type: "category"},
      {prop: "infrastructureServicePing.action", label: "Last Status", type: "string"},
      {prop: "infrastructureServicePing.occuredAt", label: "Occured At", type: "relativeUTC"},
      {prop: "infrastructureServicePing.scheduledAt", label: "Next run", type: "relativeUTC"},
      {prop: "infrastructureServicePing.ranAt", label: "Last ran", type: "relativeUTC"},
    ])
    let variables = {serviceId: props.serviceId}
    elements = (
      <Query query={SERVICE_INFO} variables={variables} skip={!props.serviceId} pollInterval={10000} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (error) return <GraphQLErrors error={error} />
          return (
            <PropertiesList properties={properties} data={fromJS(data)} />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Service Info" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default ServicePanel;